import yup from 'src/libraries/validator.library';
import {
  IDroneAreasForm,
  DroneAreasResponsePayloadSchema,
  DroneAreasListSchema,
} from 'src/models/drone-areas.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('droneAreas', { limit: 0 }, DroneAreasListSchema);
  },
  updatePUT: async (id: number, data: IDroneAreasForm) => {
    return http.put(
      `droneAreas/${id}`,
      data,
      DroneAreasResponsePayloadSchema
    );
  },
  addPOST: async (data: IDroneAreasForm) => {
    return http.post('droneAreas', data, DroneAreasResponsePayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`droneAreas/${id}`, yup.mixed());
  },
};

export default services;
